export interface ProductoAreaImplementacion{
    iddecinvproductoareaimplementacion: number,
    iddecinvproyectoprodtermin: number,
    areaimplementacion?: string,
    ultimoCambio: Date
}

export function GetVoidAreaImplementacion():ProductoAreaImplementacion{
    return{
        iddecinvproductoareaimplementacion: 0,
        iddecinvproyectoprodtermin: 0,
        areaimplementacion: "",
        ultimoCambio: new Date()
    }
}

export function setAreaImplementacion(row: any):ProductoAreaImplementacion{
    return{
        iddecinvproductoareaimplementacion: row.iddecinvproductoareaimplementacion??0,
        iddecinvproyectoprodtermin: row.iddecinvproyectoprodtermin??0,
        areaimplementacion: row.areaimplementacion??"",
        ultimoCambio: new Date()
    }
}